import { Box, Flex, Text, VStack } from '@chakra-ui/react';
import { ColorPicker } from 'modules/Editor/components/ColorPicker';
import { SliderNumberInput } from 'modules/common/components/Input';
import { useTranslation } from 'react-i18next';
import { useWidget } from 'widgets/sdk';

import { ADJUSTMENT_MAX } from '../../ImageWidget.config';
import { ImageWidgetData } from '../../ImageWidget.types';

export const ColorField = () => {
  const { t } = useTranslation('editor_widget_toolbar', { keyPrefix: 'imageToolbar', useSuspense: false });
  const { filter = {}, updateWidget } = useWidget<ImageWidgetData>();
  const { colorOverlay: { color = '' } = {} } = filter;

  const handleChangeOverlayColor = (newColor: string) => {
    updateWidget({
      filter: {
        colorOverlay: {
          color: newColor,
        },
      },
    });
  };

  return (
    <Flex w={'full'} placeContent={'space-between'} px={6}>
      <Text fontSize={'sm'} fontWeight='normal'>
        {t('settingsSideBar.color')}
      </Text>
      <ColorPicker color={color} showNoColorChecker showOpacityOption={false} onChange={handleChangeOverlayColor} />
    </Flex>
  );
};

export const OpacityField = () => {
  const { t } = useTranslation('editor_widget_toolbar', { keyPrefix: 'imageToolbar', useSuspense: false });
  const { filter = {}, updateWidget } = useWidget<ImageWidgetData>();
  const { colorOverlay: { opacity = 0 } = {} } = filter;

  const handleChangeOverlayOpacity = (newValue: number) => {
    updateWidget({
      filter: {
        colorOverlay: {
          opacity: newValue,
        },
      },
    });
  };

  return (
    <Box w={'full'} px={6}>
      <SliderNumberInput
        title={t('settingsSideBar.opacity')}
        value={opacity}
        onChange={handleChangeOverlayOpacity}
        minValue={0}
        maxValue={ADJUSTMENT_MAX}
        step={1}
        precision={1}
        suffix={''}
        sliderWidth={144}
        fontWeight='normal'
        containerProps={{ gap: '0.375rem', w: 'full' }}
      />
    </Box>
  );
};

export const ColorOverlay = () => {
  return (
    <VStack>
      <ColorField />
      <OpacityField />
    </VStack>
  );
};

export default ColorOverlay;
